'use strict';

import resizeStore from '../resize/resize.store';
import {prefixedCSSValue} from '../utils';
import Draggable from 'gsap/Draggable';
import SplitText from 'SplitText';


class Marquee extends HTMLElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this.handleResize = () => this._onResize();
  }
  connectedCallback() {
    this.container = this.querySelector('.marquee-container');
    this.inner = this.querySelector('.marquee-inner');

    this.inners = [];

    let from = '0%';
    let to = '-100%';

    if (this.classList.contains('reverse')) {
      from = '-100%';
      to = '0%';
    }

    this.tween = TweenMax.fromTo(this.container, 1, {
      x: from
    }, {
      x: to,
      repeat: -1,
      ease: 'linear'
    });



    this._onResize();
    resizeStore.eventEmitter.subscribe(this.handleResize);
  }
  disconnectedCallback() {
    resizeStore.eventEmitter.unsubscribe(this.handleResize);

    this.tween.kill();
  }

  _onResize() {
    const w = this.offsetWidth;
    const wi = this.inner.offsetWidth;

    const count = Math.ceil(w / wi) + 1;

    if (count > this.inners.length) {
      const size = count - this.inners.length;
      for (let i = 0; i < size; i++) {
        const clone = this.inner.cloneNode(true);
        clone.style.left = 100 * (this.inners.length + 1) + '%';
        this.inners.push(clone);
        this.container.appendChild(clone);
      }
    }

    this.tween.duration(wi / w * 20 * (w / 1920));
    // this.style.setProperty('--time', wi / w * 20 * (w / 1920) + 's');
  }
}

window.customElements.define('marquee-view', Marquee);